import React, { useEffect, useState } from "react";
import Button from "../../components/common/button";
import WheelSpinner from "../../components/animation/spinner";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  getJackpotNumberData,
  getWinnersData,
} from "../../redux/slices/winnersSlice";
import { clearTickets } from "../../redux/slices/purchaseTicketsSlice";

const Result = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [showPopup, setShowPopup] = useState(false);
  const { jackpotNumber, winners } = useSelector((state) => state.winners);
  const lotteryNumber = jackpotNumber?.number;
  const user_id = localStorage.getItem("userID");

  useEffect(() => {
    // Fetch jackpot data on mount
    dispatch(getJackpotNumberData());
  }, [dispatch]);

  // Check if the current user_id matches any winner's user_id
  const isUserWinner = winners.some(
    (winner) => winner.user_id.toString() === user_id
  );

  useEffect(() => {
    if (isUserWinner) {
      // Dispatch action to fetch winners data from API
      dispatch(getWinnersData());

      setTimeout(() => {
        navigate("/lottery-result");
      }, 24000);
    } else {
      // Show popup for non-winners after 24 seconds
      setTimeout(() => {
        setShowPopup(true);
      }, 24000);
    }
  }, [isUserWinner, dispatch, navigate]);

  const handleNavigate = () => {
    dispatch(clearTickets());
    navigate("/");
  };

  return (
    <div className="flex flex-col justify-center items-center w-full mx-auto mt-10">
      {/* Image */}
      <div className="flex justify-center items-center mb-6 w-60 h-7">
        <img src="/images/jackpot.png" alt="jackpot" className="mt-32" />
      </div>

      {/* Circle with Number */}
      <div className="flex justify-center items-center mt-2">
        <div
          className="w-20 h-20 mt-3"
          style={{ backgroundColor: "transparent" }}
        ></div>
      </div>

      {/* Spinner */}
      <WheelSpinner lotteryNum={lotteryNumber} />

      <div className="mb-2 mt-3">
        <Button text={"Next"} onClick={handleNavigate} />
      </div>

      {/* Popup */}
      {showPopup && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50"
          style={{ animation: "fadeIn 0.5s ease-in-out" }}
        >
          <div
            className="bg-[#0A0A0A] rounded-2xl shadow-2xl p-6 w-80 max-w-sm text-center transform"
            style={{
              boxShadow:
                "0px 4px 12px #EBC377, 0px -4px 12px #EBC377, 4px 0px 12px #EBC377, -4px 0px 12px #EBC377",
              animation: "zoomIn 0.8s ease-out",
            }}
          >
            <h2
              className="text-xl md:text-2xl font-extrabold mb-3 text-[#E7B76A]"
              style={{ animation: "pulse 1.5s infinite" }}
            >
              {t("betturLuckPopup.title")}
            </h2>
            <p className="text-white mb-4 text-base md:text-lg">
              {t("betturLuckPopup.message")}
            </p>
            <div className="flex justify-center space-x-3">
              <button
                onClick={() => setShowPopup(false)}
                className="px-4 py-2 rounded-full bg-red-700 text-white text-base md:text-lg font-semibold shadow-md hover:scale-105 hover:shadow-lg transform transition-all duration-300"
              >
                {t("betturLuckPopup.close")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Result;
